import { Button, CircularProgress, Typography } from "@mui/material";
import { React } from "react";

const AppButton = (props) => {
  const {
    buttonText,
    clickHandler,
    size = "medium",
    variant = "contained",
    sx,
    disabled = false,
    loading = false,
    startIcon,
    endIcon,
    helperText,
  } = props;

  return (
    <Button
      color="primary"
      elevation="0"
      sx={{
        ...sx,
        borderRadius: "6px",
        boxShadow: "none",
        
        "&:hover": {
          boxShadow: "none",
        },
        height: "max-content",
      
      }}
      onClick={clickHandler}
      variant={variant}
      size={size}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {!loading ? buttonText : <CircularProgress size={24} color="secondary" />}
         {helperText && (
            <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
              {helperText}
            </Typography>
          )}
    </Button>
  );
};

export default AppButton;
